<template>
  <quickfacts
    class="product-quick-facts"
    :quickfacts="quickfacts"
    :split-values="splitValues"
  />
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import Quickfacts from '../quickfacts/quickfacts.vue';
  import productStore, {ProductStore} from '../../stores/product/ProductStore';
  import Quickfact from '../../types/Quickfact';

  @Options({
    name: 'product-quickfacts',
    components: {Quickfacts}
  })
  export default class ProductQuickfacts extends Vue {
    @Prop({default: false})
    splitValues: boolean;

    productStore: ProductStore = productStore;

    get quickfacts(): Array<Quickfact> {
      return this.productStore.productDetails.quickfacts;
    }
  }
</script>
